import React from "react";
import { Card, Collapse } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ReactComponent as CollapseSVG } from "go-core/images/svg/actions/collapse.svg";
import { VenueSettingsApi } from "../../../../../../../../../../../../services/Api/Organization/types";
import { VenueSettingsItemApi } from "../../../../../../../../../../../../services/Api/types";
import useCollapseCard from "../../hooks/useCollapseCard";
import { getSettingsKioskBasicTypes, getSettingsKioskTypes } from "../../utils";
import KioskSettingsBasicCard from "./KioskSettingsBasicCard";
import KioskSettingsColorsCard from "./KioskSettingsColorsCard";
import KioskSettingsImagesCard from "./KioskSettingsImagesCard";
import KioskSettingsMenuCard from "./KioskSettingsMenuCard";
import KioskSettingsOrderTypes from "./KioskSettingsOrderTypes";
import KioskSettingsTable from "./KioskSettingsTable";
import KioskSettingsTextsCard from "./KioskSettingsTextsCard";

interface Props {
	form: UseFormReturn<VenueSettingsApi>;
	search: string;
	settings: VenueSettingsItemApi[];
}

const KioskSettingsCard = ({ search, form, settings }: Props) => {
	const { t } = useTranslation();
	const getSearchedResults = () => {
		const searchToLowerCase = search.toLowerCase();
		if (!search) return false;

		return (
			t("components.navigation.menu").toLowerCase().includes(searchToLowerCase) ||
			t("modules.venue_settings.field.colors.title").toLowerCase().includes(searchToLowerCase) ||
			t("modules.venue_settings.field.font_color.title").toLowerCase().includes(searchToLowerCase) ||
			t("modules.venue_settings.field.accent_color.title").toLowerCase().includes(searchToLowerCase) ||
			t("modules.venue_settings.field.background_color.title").toLowerCase().includes(searchToLowerCase) ||
			t("modules.venue_settings.field.curve_color.title").toLowerCase().includes(searchToLowerCase) ||
			t("modules.venue_settings.field.edit_order_description.title").toLowerCase().includes(searchToLowerCase) ||
			t("modules.venue_settings.field.edit_order_header.title").toLowerCase().includes(searchToLowerCase) ||
			t("modules.venue_settings.field.start_order_description.title").toLowerCase().includes(searchToLowerCase) ||
			t("modules.venue_settings.field.start_order_header.title").toLowerCase().includes(searchToLowerCase) ||
			t("common.word.language").toLowerCase().includes(searchToLowerCase) ||
			t("modules.venue_settings.field.logo.title").toLowerCase().includes(searchToLowerCase) ||
			t("modules.venue_settings.field.background.title").toLowerCase().includes(searchToLowerCase) ||
			t("modules.venue_settings.field.header.title").toLowerCase().includes(searchToLowerCase) ||
			t("modules.venue_settings.field.images.title").toLowerCase().includes(searchToLowerCase) ||
			t("modules.venue_settings.field.kiosk_working_schedule.title").toLowerCase().includes(searchToLowerCase)
		);
	};
	const { toggleCollapse, collapseIn, getCollapseIconStyles } = useCollapseCard(
		search,
		[...getSettingsKioskBasicTypes(settings), ...getSettingsKioskTypes(settings)],
		getSearchedResults()
	);

	return (
		<Card className="venue-settings kiosk-venue-settings">
			<Card.Body>
				<div className="title" onClick={() => toggleCollapse()}>
					<h5>{t("modules.venue_settings.field.kiosk_settings.title")}</h5>
					<CollapseSVG className="collapse-icon" style={getCollapseIconStyles()} />
				</div>
				<Collapse in={collapseIn}>
					<div>
						<KioskSettingsBasicCard form={form} settings={settings} search={search} />
						<KioskSettingsMenuCard form={form} />
						<KioskSettingsOrderTypes form={form} />
						<KioskSettingsColorsCard form={form} collapseIn={collapseIn} />
						<KioskSettingsTextsCard form={form} />
						<KioskSettingsImagesCard form={form} />
						<KioskSettingsTable form={form} settings={settings} search={search} />
					</div>
				</Collapse>
			</Card.Body>
		</Card>
	);
};

export default KioskSettingsCard;
